import slugify from 'slugify'

export const slugifyHeading = heading => slugify(heading)

export const getHeadingNameFromContent = headingNode => headingNode.content[0].value
